import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/app.materials';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-house-views-readonly',
  templateUrl: './house-views-readonly.component.html',
  styleUrls: ['./house-views-readonly.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialModule, FormsModule],
})
export class HouseViewsReadonlyComponent {
  @Input() views: any[] = [];
  @Input() label = '';
  @Input() sourceKey: 'firm' | 'user' = 'firm';
  @Input() enabledMap: Record<string, boolean> = {};

  @Output() masterToggleChange = new EventEmitter<boolean>();
  @Output() viewToggleChange = new EventEmitter<{ viewKey: string; enabled: boolean }>();

  collapsed = false;

  types = [
    { id: 'asset', name: 'Asset' },
    { id: 'sector', name: 'Sector' },
    { id: 'country', name: 'Country' },
    { id: 'index', name: 'Market Factors' },
    { id: 'currency', name: 'Currency' },
  ];

  get masterEnabled(): boolean {
    if (!this.views.length) return false;
    return this.views.every(v => this.enabledMap[this.getViewKey(v)] !== false);
  }

  get allDisabled(): boolean {
    if (!this.views.length) return true;
    return this.views.every(v => this.enabledMap[this.getViewKey(v)] === false);
  }

  getViewKey(v: any): string {
    const typeId = v.type?.id || v.type;
    const itemId = v.items?.[0]?.id || 'unknown';
    // Relative views: {type}_{itemId}_vs_{sorted_items2_ids_joined_by_hyphen}
    if (v.items2 && v.items2.length) {
      const sortedItems2 = v.items2.map((i: any) => +i.id).sort((a, b) => a - b).join('-');
      return `${typeId}_${itemId}_vs_${sortedItems2}`;
    }
    return `${typeId}_${itemId}`;
  }

  getTypeName(type: any): string {
    if (!type) return '';
    const id = type.id || type;
    const found = this.types.find(t => t.id === id);
    return found ? found.name : id;
  }

  getItemNames(v: any): string {
    if (!v.items || !v.items.length) return '';
    return v.items.map((i: any) => i.name).join(', ');
  }

  onMasterToggle(event: any): void {
    this.masterToggleChange.emit(event.checked);
  }

  onViewToggle(v: any, event: any): void {
    this.viewToggleChange.emit({
      viewKey: this.getViewKey(v),
      enabled: event.checked,
    });
  }
}
